/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Numberofteachers2Inputs */

const de__field_numberofteachers2 = /** @type {(inputs: _Field_Numberofteachers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl der Lehrer:innen`)
};

/**

* @param {_Field_Numberofteachers2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_numberofteachers2 = /** @type {((inputs?: _Field_Numberofteachers2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Numberofteachers2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_numberofteachers2(inputs)
});
export { _field_numberofteachers2 as "_field_numberOfTeachers" }